import defaultParams from './default-params';

const SliderPlaceholder = ({ children, className, params, pagination: paginationProp }) => {
	const { slideTag: SlideTag, wrapperTag: WrapperTag, tag: Tag, slidesPerView, pagination: paginationParam } = {
		...defaultParams,
		...params,
	}

	return (
		<section className={`sliderelem loading ${className}`}>
			<Tag className="sliderelem-swiper">
				<WrapperTag className="swiper-wrapper">
					{children && children.map((child, nth) => (
						<SlideTag
							key={`loading-${nth}`}
							style={{ width: `${100 / slidesPerView}%`, }}
							className={`swiper-slide ${nth < slidesPerView ? 'swiper-slide-active' : ''}`}>
							{child}
						</SlideTag>
					))}
				</WrapperTag>
			</Tag>
			{!!(paginationProp || paginationParam) &&
				<div className="sliderelem-pagination"></div>
			}
		</section>
	)
}

export default SliderPlaceholder;